import { getSession } from '../services/supabaseClient';

/**
 * Build request headers with the current user's Supabase JWT attached.
 * AI endpoints require authentication (to prevent unmetered spend), so any
 * fetch to them must send the token when the user is signed in.
 */
export async function authHeaders(base = {}) {
  try {
    const session = await getSession();
    const token = session?.access_token;
    return token ? { ...base, Authorization: `Bearer ${token}` } : base;
  } catch (_) {
    return base;
  }
}

export default authHeaders;
